<template>
  <div class="suggestion-list" :style="{height}">
    <div v-for="option in options" @click="$emit('change',option)">{{
        option
      }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SuggestionList",
  props: {
    options: {type: Array, default: () => []}
  },
  computed: {
    height() {
      if (this.options.length === 0) {
        return "0px"
      }
      return ((this.options.length * 35) + 30) + 'px'
    }
  }
}
</script>

<style scoped>

</style>
